export class Persona {
  // public id:number;
  public tipoDocumento = '';
  public numeroDocumento = '';
  public nombres = '';
  public apellidos = '';
  public correo = '';
}
